import { isLive, isPreMatch } from '@/constants/matchStatus';

/** Pre-match fixtures kicking off within this window count as "about to go live". */
const KICKOFF_SOON_MS = 5 * 60_000;
/**
 * A pre-match fixture whose kickoff passed longer ago than this is stale data
 * (postponed / never synced), not a match about to start — it must not keep
 * a view polling forever.
 */
const KICKOFF_STALE_MS = 3 * 60 * 60_000;

export interface PollableMatch {
  status: string;
  match_date: string;
}

/**
 * True when a pre-match fixture kicks off within the next five minutes, or its
 * kickoff passed recently without a status change yet — polling then picks up
 * the switch to live without a reload.
 */
export function isKickoffImminent(match: PollableMatch, nowMs: number = Date.now()): boolean {
  if (!isPreMatch(match.status)) return false;
  const kickoff = Date.parse(match.match_date);
  return kickoff <= nowMs + KICKOFF_SOON_MS && kickoff > nowMs - KICKOFF_STALE_MS;
}

/**
 * Single polling rule of every live match view (`/matches` day list, league
 * season list, standalone match page): poll while any match is live or about
 * to kick off, stay quiet otherwise.
 */
export function needsMatchPolling(
  matches: readonly PollableMatch[],
  nowMs: number = Date.now(),
): boolean {
  return matches.some(match => isLive(match.status) || isKickoffImminent(match, nowMs));
}
